import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "buttons-container" }
const _hoisted_4 = { class: "info-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShatterButton = _resolveComponent("ShatterButton")!
  const _component_RippleButton = _resolveComponent("RippleButton")!
  const _component_IonExplosionButton = _resolveComponent("IonExplosionButton")!
  const _component_JellyButton = _resolveComponent("JellyButton")!
  const _component_BlackHoleButton = _resolveComponent("BlackHoleButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("header", { class: "app-header" }, [
      _createElementVNode("h1", null, "特效按钮演示"),
      _createElementVNode("p", null, "点击下面的按钮，体验不同的视觉效果！")
    ], -1)),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ShatterButton, {
          "button-text": "点击炸裂屏幕",
          "shard-count": 50,
          "crack-count": 10,
          "animation-duration": 2000,
          onClick: _ctx.handleShatterClick
        }, null, 8, ["onClick"]),
        _createVNode(_component_RippleButton, {
          "button-text": "点击水波效果",
          "ripple-color": "#3498db",
          "ripple-count": 5,
          duration: 2000,
          onClick: _ctx.handleRippleClick
        }, null, 8, ["onClick"]),
        _createVNode(_component_IonExplosionButton, {
          "button-text": "离子爆炸",
          "color-scheme": "neon",
          "particle-count": 150,
          "ray-count": 20,
          duration: 2500,
          onClick: _ctx.handleIonClick
        }, null, 8, ["onClick"]),
        _createVNode(_component_JellyButton, {
          "button-text": "果冻按钮",
          "button-color": "#FF6B6B",
          intensity: 1.2,
          duration: 1200,
          onClick: _ctx.handleJellyClick
        }, null, 8, ["onClick"]),
        _createVNode(_component_BlackHoleButton, {
          "button-text": "召唤卡冈图雅",
          intensity: 1.3,
          duration: 6000,
          onClick: _ctx.handleBlackHoleClick
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", null, "点击统计", -1)),
        _createElementVNode("p", null, "破裂效果点击: " + _toDisplayString(_ctx.shatterClickCount) + " 次", 1),
        _createElementVNode("p", null, "水波效果点击: " + _toDisplayString(_ctx.rippleClickCount) + " 次", 1),
        _createElementVNode("p", null, "离子爆炸点击: " + _toDisplayString(_ctx.ionClickCount) + " 次", 1),
        _createElementVNode("p", null, "果冻按钮点击: " + _toDisplayString(_ctx.jellyClickCount) + " 次", 1),
        _createElementVNode("p", null, "黑洞按钮点击: " + _toDisplayString(_ctx.blackHoleClickCount) + " 次", 1),
        _createElementVNode("p", null, " 总点击次数: " + _toDisplayString(_ctx.shatterClickCount + _ctx.rippleClickCount + _ctx.ionClickCount + _ctx.jellyClickCount + _ctx.blackHoleClickCount) + " 次 ", 1),
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"description\"><h3>关于这些效果</h3><p>这是使用Vue3和TypeScript实现的五种不同的视觉交互效果:</p><ul><li><strong>破裂效果</strong> - 模拟屏幕被击碎的效果，碎片向四周飞散 </li><li><strong>水波效果</strong> - 模拟水滴落入水面产生的同心圆波纹 </li><li><strong>离子爆炸</strong> - 模拟炫目的离子光束和粒子爆炸效果 </li><li><strong>果冻按钮</strong> - 模拟真实的果冻物理效果，按钮点击后会像果冻一样晃动 </li><li><strong>黑洞效果</strong> - 模拟宇宙黑洞的视觉效果，空间扭曲、光线弯曲和吸积盘旋转 </li></ul><p>这些效果都使用先进的前端技术实现，包括Canvas动态绘制、SVG路径动画、基于物理的弹簧动画系统以及复杂的粒子系统，可以根据需要进行自定义配置。</p></div>", 1))
      ])
    ])
  ]))
}